/**
 * alias 化する GraphQL ID の kind と、model に見せる短い prefix。
 *
 * ブラウザの表示用伏せ字処理からも参照するため、Node 専用依存を持たせない。
 */
export const ID_ALIAS_KIND_PREFIXES = {
  Organization: "org",
  Project: "proj",
  SearchAnalytics: "sa",
  SearchAnalyticsView: "saview",
  UserAnalytics: "ua",
  UserAnalyticsView: "uaview",
  IndexWorker: "iw",
  IndexWorkerJob: "iwjob",
  Property: "property",
  QueryGroup: "qgroup",
  URLGroup: "urlgroup",
  SearchAnalyticsBigQuery: "sabq",
  UserAnalyticsBigQuery: "uabq",
  ServiceAccount: "svcacct",
  Dashboard: "dashboard",
  DashboardItem: "dashitem",
  WorkspaceAiWorkflowSkill: "skill",
} as const satisfies Readonly<Record<string, string>>;

/** 対応 kind に許可する alias prefix の有限集合。未対応 kind は含めず、実行時検証は呼び出し元が行う。 */
export type IdAliasPrefix =
  (typeof ID_ALIAS_KIND_PREFIXES)[keyof typeof ID_ALIAS_KIND_PREFIXES];
